export default __webpack_public_path__ + "04ef3305c3d9192cb175626c4d704876.svg";